export const maximumNumberOfSamples = 100;
export const maximumNumberOfPrimersPerReaction = 20;
export const maximumSampleSize = 999999;
export const minimumSampleSize = 1;
